import { useMemo } from "react";
import styles from "./SequenceAuditModal.module.css";
import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import { useGetSequenceAuditLogs } from "../../../api/sytem&settings/useSequences";

const formatDateTime = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
};

export default function SequenceAuditModal({ open, onClose, sequence }) {
  const { data, loading, error } = useGetSequenceAuditLogs(
    sequence?.id,
    { page: 1, limit: 100, sortBy: "changed_at", sortOrder: "DESC" },
    open && Boolean(sequence?.id)
  );
  const logs = useMemo(
    () =>
      data.map((row) => ({
        id: row.id,
        date: formatDateTime(row.changed_at),
        user: row.changed_by ?? "System",
        field: row.field_name || "—",
        from: row.old_value ?? "—",
        to: row.new_value ?? "—",
        reason: row.change_reason || "—",
      })),
    [data]
  );
  if (!sequence) return null;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={`Audit Log — ${sequence.name}`}
      width="700px"
      footer={
        <button className={styles.closeBtn} onClick={onClose}>Close</button>
      }
    >
      <div className={styles.body}>
        <div className={styles.info}>
          <span className={styles.infoItem}><b>Type:</b> {sequence.type}</span>
          <span className={styles.infoItem}><b>Prefix:</b> {sequence.prefix}</span>
          <span className={styles.infoItem}><b>Current value:</b> {sequence.currentValue}</span>
        </div>

        <table className={styles.table}>
          <thead>
            <tr>
              <th>Date / Time</th>
              <th>User</th>
              <th>Field Changed</th>
              <th>Old Value</th>
              <th>New Value</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={6} className={styles.emptyRow}>Loading audit logs...</td>
              </tr>
            )}
            {!loading && error && (
              <tr>
                <td colSpan={6} className={styles.emptyRow}>{error}</td>
              </tr>
            )}
            {!loading && !error && logs.length === 0 && (
              <tr>
                <td colSpan={6} className={styles.emptyRow}>No audit logs found.</td>
              </tr>
            )}
            {!loading && !error && logs.map((row) => (
              <tr key={row.id}>
                <td className={styles.mono}>{row.date}</td>
                <td>{row.user}</td>
                <td><span className={styles.fieldPill}>{row.field}</span></td>
                <td><span className={styles.oldVal}>{row.from}</span></td>
                <td><span className={styles.newVal}>{row.to}</span></td>
                <td className={styles.reason}>{row.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className={styles.footer}>
          <span className={styles.footerNote}>
            📋 Audit log is immutable — entries cannot be edited or deleted.
          </span>
          <button className={styles.exportBtn} disabled>⬇ Export CSV</button>
        </div>
      </div>
    </BaseModal>
  );
}